import Clock from "assets/svg/clock.svg";
import SideArrow from "assets/svg/leftArrow.svg";
import Profile from "assets/svg/newCourses/profile.svg";
import Button from "components/Button";
import Link from "next/link";
import React, { FC, useEffect, useState } from "react";
import { commafy, convertToJalali, getClassFormat } from "src/utils";
import { Swiper, SwiperSlide } from "swiper/react";

import { Title } from "..";

type Props = {
  data: any;
  isShallow?: boolean;
  breakpoints?: any;
  title: string;
};

const Card = ({ item, isShallow = false, title }: any) => {
  const convertUrlType = (title: string) => {
    let type = "course";
    if (title === "دوره ها و بسته های پیشنهادی") {
      type = item.entityType === 0 ? "course" : "package-details";
    }
    return type;
  };
  // href={{
  //   href: `/course/${item?.id}`,
  //     pathname: item?.seoUrlDescription
  //     ? `/course/${item?.id}/${encodeURIComponent(item?.seoUrlDescription)}`
  //     : `/course/${item?.id}`,
  // }}
  // href={{
  //   href: `/${item.entityType === 0 ? "course" : "package-details"}/${item?.id}`,
  //     pathname: item?.seoUrlDescription
  //     ? `/${item.entityType === 0 ? "course" : "package-details"}/${item?.id}/${encodeURIComponent(item?.seoUrlDescription)}`
  //     : `/${item.entityType === 0 ? "course" : "package-details"}/${item?.id}`,
  // }}

  return (
    <Link
      shallow={isShallow}
      href={{
        href: `/${convertUrlType(title)}/${item?.id}`,
        pathname: item?.seoUrlDescription
          ? `/${convertUrlType(title)}/${item?.id}/${encodeURIComponent(
              item?.seoUrlDescription
            )}`
          : `/${convertUrlType(title)}/${item?.id}`,
      }}
    >
      <a className="w-full">
        <div
          style={{
            contain: "content",
            borderColor: "#0577AF",
          }}
          className="relative flex h-[400px] w-full cursor-pointer flex-col rounded-lg border-b-2 shadow"
        >
          <div className="relative flex max-h-[45%] min-h-[45%] w-full items-center justify-between">
            <img
              loading="lazy"
              src={item?.image}
              className="h-full w-full object-cover"
              alt={(item?.name as string) || (item?.title as string)}
              width="270px"
              height="180px"
            />
            {item?.certificateImage && (
              <img
                loading="lazy"
                src={item?.certificateImage}
                alt="icon"
                className="absolute top-24 right-5 z-10 h-16 w-16 rounded"
              />
            )}{" "}
          </div>
          <div className="relative z-10 flex h-[55%] flex-col justify-between text-white">
            <div className="grid w-full px-3 text-sm sm:px-3">
              <p className="overflow-hidden overflow-ellipsis whitespace-nowrap text-[15px] md:max-w-[100%]">
                {(item?.name as string) || (item?.title as string)}
              </p>
              <div className="mt-7 space-y-3 text-xs">
                <div className="flex">
                  <Clock className="ml-2 fill-white" />
                  <p>
                    {item?.startDate
                      ? convertToJalali(item?.startDate)
                      : convertToJalali(item?.releaseDatetime)}{" "}
                    - {item?.hour && `${item?.hour} -`}{" "}
                    {getClassFormat(
                      item.entityType === 0
                        ? item?.courseType
                        : item?.packageType
                    )}
                  </p>
                </div>
                {item?.teacherNames && (
                  <div className="flex">
                    <Profile className="ml-2 fill-white" />
                    <p className="scrollbar-none overflow-hidden overflow-ellipsis whitespace-normal">
                      {item?.teacherNames}{" "}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="flex w-full items-center justify-between px-5 pb-5 lg:px-3">
              <div className="flex md:flex-col 4xl:flex-row">
                {item?.isBuyable && (
                  <>
                    {item?.price === 0 ? (
                      "رایگان"
                    ) : (
                      <>
                        <span className="ml-1 whitespace-nowrap text-base 2xl:ml-3">
                          {item?.discount !== null && item?.discount !== 0
                            ? commafy(item?.discount)
                            : commafy(item?.price)}{" "}
                          تومان
                        </span>
                        {item?.discount !== null && item?.discount !== 0 && (
                          <span className="flex items-center whitespace-nowrap text-sm line-through">
                            {item?.price && commafy(item?.price)} تومان
                          </span>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              {item?.price === 0 && item?.isBuyable ? (
                <Button
                  // isLoading={isLoading}
                  spinnerColor="blue"
                  // onClick={(e) => {
                  //     e.stopPropagation();
                  //     handlePay({
                  //         discount: item?.discount,
                  //         id: item?.id,
                  //         price: item?.price,
                  //     });
                  // }}
                  className="rounded-lg bg-white py-2 px-2 text-base text-blue md:text-base xl:px-4 xl:text-base"
                >
                  افزودن به داشبورد
                </Button>
              ) : (
                <Button
                  // isLoading={isLoading}
                  spinnerColor="blue"
                  // onClick={(e) => {
                  //     e.stopPropagation();
                  //     handlePay({
                  //         discount: item?.discount,
                  //         id: item?.id,
                  //         price: item?.price,
                  //     });
                  // }}
                  className="rounded-lg bg-white py-2 px-3 text-blue sm:px-5"
                >
                  خرید
                </Button>
              )}
            </div>
          </div>
          <div
            style={{
              clipPath: "polygon(0 23%, 100% 34%, 100% 100%, 0 100%)",
              background:
                "linear-gradient(180deg, #0577AF 7.29%, #046696 100%)",
            }}
            className="absolute -bottom-5 right-0 flex h-[100%] w-full flex-col justify-between pb-5"
          />
        </div>
      </a>
    </Link>
  );
};

const NewCourses: FC<Props> = ({
  data,
  breakpoints = {
    300: {
      slidesPerView: 1,
      spaceBetween: 5,
    },
    375: {
      slidesPerView: 1.1,
      spaceBetween: 5,
    },
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
  title,
  isShallow,
}) => {
  const [slidePosition, setSlidePosition] = useState({
    isEnd: false,
    isBeginning: true,
  });

  const [swiperRef, setSwiperRef]: any = useState();
  useEffect(() => {
    if (data && data.length) {
      setSlidePosition({
        isEnd: isEnoughSlides(),
        isBeginning: true,
      });
    }
  }, [data]);
  useEffect(() => {
    function updateSize() {
      if (data && data.length) {
        setSlidePosition({
          isEnd: isEnoughSlides(),
          isBeginning: true,
        });
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  const isEnoughSlides = () => {
    const windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth > 1024: {
        return !(data.length > 4);
      }
      case windowWidth > 767: {
        return !(data.length > 2);
      }
      case windowWidth > 375: {
        return !(data.length > 1);
      }
      default: {
        return false;
      }
    }
  };
  return (
    // 2xl:h-[520px]
    <div className="z-10 flex w-full flex-col">
      <div className="mb-4 flex w-full items-center justify-between md:mb-9">
        <div className="">
          <Title title={title} hideLinesOnResponsive="hidden md:flex" />
        </div>
        <div className="grid items-center gap-x-5 pl-[10%] text-blue md:pl-0 lg:grid-cols-3">
          <Link href={"/search"}>
            <a>
              <span className="cursor-pointer">همه</span>
            </a>
          </Link>
          <SideArrow
            className={`hidden rotate-180 cursor-pointer lg:block ${
              slidePosition?.isBeginning ? "fill-slate-300" : "fill-[#0577AF]"
            }`}
            onClick={() => swiperRef?.slidePrev()}
          />
          <SideArrow
            className={`hidden cursor-pointer lg:block ${
              slidePosition?.isEnd ? "fill-slate-300" : "fill-[#0577AF]"
            }`}
            onClick={() => swiperRef?.slideNext()}
          />
        </div>
      </div>
      <div className="relative h-auto text-white">
        <Swiper
          onSlideChange={(e) =>
            setSlidePosition({ isBeginning: e.isBeginning, isEnd: e.isEnd })
          }
          onSwiper={(e) => {
            setSwiperRef(e);
            // setSlidePosition({
            //   isBeginning: e?.isBeginning,
            //   isEnd: swiperRef?.isEnd,
            // });
          }}
          className="flex justify-center"
          breakpoints={breakpoints}
        >
          {data?.map((item: any) => (
            <SwiperSlide
              key={item?.id?.toString()}
              className="flex justify-center"
            >
              <Card item={item} isShallow={isShallow} title={title} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default NewCourses;
